var _defs, _path, _path2, _ellipse, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _rect, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _circle, _rect2, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _circle2, _rect3, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _circle3, _rect4, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65, _circle4, _rect5, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _ellipse70, _ellipse71, _ellipse72, _ellipse73, _ellipse74, _ellipse75, _ellipse76, _ellipse77, _ellipse78, _ellipse79, _ellipse80, _ellipse81, _circle5, _rect6, _ellipse82, _ellipse83, _ellipse84, _ellipse85, _ellipse86, _ellipse87, _ellipse88, _ellipse89, _ellipse90, _ellipse91, _ellipse92, _ellipse93, _ellipse94, _ellipse95, _ellipse96, _ellipse97, _circle6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpringOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ddcd00;\n        stroke: #ddcd00;\n      }\n\n      .st0, .st1, .st2, .st3, .st4 {\n        stroke-width: 1.6px;\n      }\n\n      .st0, .st2, .st3 {\n        stroke-miterlimit: 10;\n      }\n\n      .st1 {\n        stroke: #a55a3c;\n      }\n\n      .st1, .st5, .st4 {\n        fill: none;\n      }\n\n      .st1, .st4, .st6 {\n        stroke-linecap: round;\n        stroke-miterlimit: 17.9;\n      }\n\n      .st7 {\n        fill: #4d4d4d;\n      }\n\n      .st2 {\n        fill: #fceb3f;\n        stroke: #fceb3f;\n      }\n\n      .st8 {\n        fill: #a9c4e1;\n      }\n\n      .st9 {\n        fill: #fff;\n      }\n\n      .st10 {\n        fill: #5fb130;\n      }\n\n      .st10, .st11, .st12 {\n        fill-rule: evenodd;\n      }\n\n      .st3 {\n        fill: #34912e;\n        stroke: #34912e;\n      }\n\n      .st13 {\n        fill: #a88c5d;\n      }\n\n      .st14 {\n        fill: #704e2c;\n      }\n\n      .st15 {\n        fill: #f5f6f6;\n      }\n\n      .st16, .st11 {\n        fill: #4a311a;\n      }\n\n      .st17 {\n        fill: #bd9d67;\n      }\n\n      .st18 {\n        fill: #4d331b;\n      }\n\n      .st4 {\n        stroke: #783c28;\n      }\n\n      .st19 {\n        fill: #d5bf8e;\n      }\n\n      .st6 {\n        stroke: #e31600;\n        stroke-width: .8px;\n      }\n\n      .st6, .st20 {\n        fill: #e31600;\n      }\n\n      .st21 {\n        fill: #f1eada;\n      }\n\n      .st22 {\n        fill: #f6931c;\n      }\n\n      .st23 {\n        fill: #592a15;\n      }\n\n      .st24 {\n        fill: #e7e7e7;\n      }\n\n      .st25 {\n        fill: #462212;\n      }\n\n      .st12 {\n        fill: #0e7b61;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M0,0h1600v1000H0V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-.4,808.4c263-24.3,515.5-3.3,758.6,82.3,33.3,11.7,58,11.1,90.5.2,19.7-6.6,39.3-13.3,58.9-19.9,199.5-68.3,397.6-90.1,692-57.8v187.3H-.4s1-176,0-192H-.4Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 1334.7,
    cy: 816,
    rx: 20.9,
    ry: 12.6,
    transform: "translate(-169.5 386.4) rotate(-15.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M191.5,788.2c0,.2-1.8-.5-2-.6-.9-.6-1.9-.4-1.6.6.3,1.1,1.9,1.5,3.1,1.6l.5-1.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M189.3,788.1c.8,1.6.8,3.4-.1,3.8-.9.5-2.3-.5-3.1-2.2-.8-1.6-.8-3.4.1-3.8s2.3.5,3.1,2.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M186.9,787.3c.6-.3,1.2-.4,1.9-.3v-.2c-.5-1-1.6-1.4-2.5-1s-1.2,1.6-.7,2.6v.2c.3-.6.8-1.1,1.3-1.3h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M186.4,786v.2h-.2l-.3-.6v-.2h.2l.3.6Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M185.8,786.9v.2s-.1,0-.2,0v-.2s.1,0,.2,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M185.8,787.6v.2s-.1,0-.2,0,0-.2,0-.2c0,0,.1,0,.2,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M186.5,787.1v.2s-.1,0-.2,0,0-.2,0-.2c0,0,.1,0,.2,0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M186.9,786.1v.2s-.1,0-.2,0,0-.2,0-.2c0,0,.1,0,.2,0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M188,786.4v.2s-.1,0-.2,0v-.2s.1,0,.2,0Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M187.3,786.6v.2s-.1,0-.2,0,0-.2,0-.2c0,0,.1,0,.2,0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M189.6,790.2c0,.6-.3,1-.4,1s0-.5,0-1v-1s.3.4.3,1h0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M175.6,798.7v7.4c0,2.3.5,4.7,0,6.9-.3,1.3-3.5,4.5-1.6,4.3,2.3-.3,4.2-.6,5.6-1.3,2-1.1,4.7-2.7,7-2,1.9.5,2.4,3,4.1,3.5,1.8.6,2.4-1.7,3.4-2.5,1.8-1.3,4.4.3,6.3.8,1.7.5,4.4,2.1,5.7.4.6-.8.7-2.1,1.6-2.4,1.4-.5,4.4,1.2,5.8,1.6,1.9.6,4.1,1.8,6.1,1-.6.2-2.2-1.5-2.5-1.9-.6-.9-.5-1.6-.6-2.6v-13.1h-41,0Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M216.5,798.7c0,2.8-9.2,5-20.5,5s-20.5-2.3-20.5-5,9.2-5,20.5-5,20.5,2.3,20.5,5Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M196,803.4c-4.9,0-9.6-.5-13.1-1.3-3.5-.9-5.5-2-5.5-3.3s1.9-2.4,5.5-3.3c3.5-.9,8.1-1.3,13.1-1.3s9.6.5,13.1,1.3c3.5.9,5.5,2,5.5,3.3s-1.9,2.4-5.5,3.3c-3.5.9-8.1,1.3-13.1,1.3ZM196,794.3c-4.9,0-9.5.5-13,1.3-3.4.8-5.3,2-5.3,3.1s1.9,2.3,5.3,3.1c3.5.9,8.1,1.3,13,1.3s9.5-.5,13-1.3c3.4-.8,5.3-2,5.3-3.1s-1.9-2.3-5.3-3.1c-3.5-.9-8.1-1.3-13-1.3h0Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M196,801.9c-4.3,0-8.4-.4-11.4-1.2-3.4-.8-4.2-1.8-4.2-2s.7-1.2,4.2-2c3-.7,7.1-1.2,11.4-1.2s8.4.4,11.4,1.2c3.4.8,4.2,1.8,4.2,2s-.7,1.2-4.2,2c-3,.7-7.1,1.2-11.4,1.2h0ZM196,795.7c-4.3,0-8.3.4-11.3,1.2-3.2.8-4,1.7-4,1.8,0,.2.8,1,4,1.8,3,.7,7,1.2,11.3,1.2s8.3-.4,11.3-1.2c3.2-.8,4-1.7,4-1.8,0-.2-.8-1-4-1.8-3-.7-7-1.2-11.3-1.2Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M196,801.3c-3.5,0-6.7-.3-9.1-.9-2.7-.7-3.3-1.4-3.3-1.7s.6-1,3.3-1.7c2.4-.6,5.7-.9,9.1-.9s6.7.3,9.1.9c2.7.7,3.3,1.4,3.3,1.7s-.6,1-3.3,1.7c-2.4.6-5.7.9-9.1.9ZM196,796.4c-3.4,0-6.7.3-9.1.9-2.9.7-3.2,1.5-3.2,1.5,0,0,.3.7,3.2,1.5,2.4.6,5.6.9,9.1.9s6.7-.3,9.1-.9c2.9-.7,3.2-1.5,3.2-1.5,0,0-.3-.7-3.2-1.5-2.4-.6-5.6-.9-9.1-.9h0Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M196,800.5c-2.3,0-4.4-.2-6-.6-1.8-.4-2.2-.9-2.2-1.1s.5-.7,2.2-1.1c1.6-.4,3.7-.6,6-.6s4.4.2,6,.6c1.8.4,2.2.9,2.2,1.1s-.5.7-2.2,1.1c-1.6.4-3.7.6-6,.6ZM188.1,798.7s.3.5,2.1.9c1.6.4,3.7.6,5.9.6s4.4-.2,5.9-.6c1.7-.4,2-.9,2.1-.9,0,0-.3-.5-2.1-.9-1.6-.4-3.7-.6-5.9-.6s-4.4.2-5.9.6c-1.7.4-2,.9-2.1.9Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M192,780.6s0-2,.3-2.3c1-1.3,2,1.2,2.1,1.9l-2.3.4h-.1Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M191.2,785.6s-3.1,8.3,0,11.6c0,0-3.3.9-.7,1.9,0,0,3.5.9,4.1-.6,0,0,2-.4,2.2-.5,3.4-1.7,1-5.9-.7-7.9-.7-.8-1.7-1.5-2.2-2.4-.2-.4-.3-.8-.3-1.2s0-1.6.4-1.6l-2.8.7Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M196.1,790.1c-.7-.8-1.7-1.5-2.2-2.4-.2-.4-.3-.8-.3-1.2s0-1.6.4-1.6c0,0-1.3.3-2.2.5v1c0,.4.1.9.3,1.3.5,1.1,1.5,1.7,2.2,2.6,1.5,2,3.6,5.8,1.6,7.9.5,0,.9-.2,1-.2,3.4-1.7,1-5.9-.7-7.9h-.1Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M190.7,788.6c0,.2-1.9,0-2.1,0-1-.3-1.9.2-1.4,1,.6,1,2.3.9,3.5.6v-1.7h0Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M197.4,796s2.9.9,1.7-3.1c-.3-.9-1-1.7-1.3-2.6-.6-1.6-1-3.7-.4-5.3.9-2.6,5.9-5.7,8.1-3.1,1.6,1.9.7,6.5-2.2,6.4-.9,0-2.1-.9-2.3-1.8-.2,2-.4,4.5.3,6.4,1,2.8-1.3,6.3-4.4,4.6l.5-1.5h0Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M186.3,782.3s3.5-3.8,7.2-2.9c1.6.4,2.8,2.2,2.6,3.8-.2,1.8-2,3.4-3.7,3.7-1.2.2-2.7-.4-3.7-1.2,0,0-3.5-2.5-2.4-3.4h0Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M191.6,781.1c-2.1-.5-4.1.5-5.5,1.5-.3,1.1,2.6,3.2,2.6,3.2.9.7,2.5,1.4,3.7,1.2.5,0,.9-.2,1.3-.5.3-.5.5-1,.6-1.5.2-1.6-1-3.4-2.6-3.8h-.1Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M194,780s1.8-1.1,2.1-1c1.6,0,0,2.3-.4,2.7l-1.6-1.7h-.1Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M186.8,782.9c0,.3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6.6.2.6.6,0,0,0,0Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M380.1,820.9c1,2.1,1,4.2-.1,4.8-1.1.6-2.9-.7-4-2.7-1-2.1-1-4.2.1-4.8s2.9.7,4,2.7Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M377.1,820c.7-.4,1.6-.5,2.3-.4,0,0,0-.1,0-.2-.6-1.2-2-1.8-3.1-1.2s-1.5,2-.9,3.2c0,0,0,.1.1.2.4-.7,1-1.3,1.6-1.6h0Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M376.4,818.2c0,0,0,.2,0,.2s-.2,0-.2,0h0l-.4-.8c0,0,0-.2,0-.2s.2,0,.2,0h0l.4.8Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M375.6,819.4v.3c0,0-.1,0-.2-.1v-.3c0,0,.1,0,.2.1Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M375.6,820.3v.3s-.1,0-.2-.1,0-.2,0-.3.1,0,.2.1Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M376.5,819.7v.3c0,0-.1,0-.2-.1s0-.2,0-.3.1,0,.2.1Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M377.1,818.4v.3c0,0-.1,0-.2-.1s0-.2,0-.3.1,0,.2.1Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M378.4,818.8v.3c0,0-.1,0-.2-.1v-.3c0,0,.1,0,.2.1Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M377.6,819.1v.3s-.1,0-.2-.1,0-.2,0-.3c0,0,.1,0,.2.1Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M380.5,823.5c0,.7-.4,1.3-.5,1.2s0-.6,0-1.3,0-1.2,0-1.3c.1,0,.4.5.4,1.3h0Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M190.2,782.6c0,.3-.2.5-.5.5s-.5-.2-.5-.5.2-.5.5-.5.5.2.5.5h0Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M189.7,782.5s0,0-.1,0c0,0-.1,0-.1,0,0,0,0,0,.1,0h0s.1,0,.1,0h0Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1462.5,802.4h-14.7v20.4h14.7v-20.4Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1505.9,802.6c-5.3,7.8-8.9,5.7-13.6,2.3-1-.7-5.3-.9-6.2,0-10.3,11.2-32.3,1.9-31-2.3-10.3,8.5-20.4,10.4-30.2,3.5-1.8-1.5-3.6-3.2-7,0-6.4,6.5-12-.7-13.4-3.5l50.6-56.3,50.7,56.3h0Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1415.3,777.8c4.1,6.1,7,4.5,10.7,1.8.8-.6,4.1-.7,4.8,0,8,8.8,25.3,1.5,24.2-1.8,8.1,6.7,15.9,8.2,23.6,2.8,1.4-1.2,2.8-2.5,5.5,0,5,5.1,9.4-.5,10.4-2.7l-39.6-44-39.6,44h0Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1484.3,756.6c-3.1,4.5-5.2,3.3-7.9,1.3-.6-.4-3.1-.5-3.6,0-5.9,6.5-18.7,1.1-17.9-1.4-6,4.9-11.8,6-17.5,2.1-1.1-.9-2.1-1.9-4,0-3.7,3.8-6.9-.4-7.7-2l29.2-32.5,29.3,32.6h0Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1432,742.2c2.4,3.6,4.1,2.6,6.2,1.1.5-.3,2.4-.4,2.8,0,4.7,5.1,14.7.9,14.1-1.1,4.7,3.9,9.3,4.8,13.8,1.6.8-.7,1.6-1.5,3.2,0,2.9,3,5.5-.3,6.1-1.6l-23.1-25.6-23.1,25.7h0Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1435.9,730.9c2,4.4,3.3,3.2,5.1,1.3.4-.4,2-.5,2.3,0,3.8,6.4,12.1,1.1,11.6-1.3,3.9,4.8,7.6,5.9,11.3,2,.7-.8,1.4-1.8,2.6,0,2.4,3.7,4.5-.4,5-2l-18.9-31.9-19,31.9Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1243.3,802.4h-14.7v20.4h14.7v-20.4Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1286.7,802.6c-5.3,7.8-8.9,5.7-13.6,2.3-1-.7-5.3-.9-6.2,0-10.3,11.2-32.3,1.9-31-2.3-10.3,8.5-20.4,10.4-30.2,3.5-1.8-1.5-3.6-3.2-7,0-6.4,6.5-12-.7-13.4-3.5l50.6-56.3,50.7,56.3h0Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1196.1,777.8c4.1,6.1,7,4.5,10.7,1.8.8-.6,4.1-.7,4.8,0,8,8.8,25.3,1.5,24.2-1.8,8.1,6.7,15.9,8.2,23.6,2.8,1.4-1.2,2.8-2.5,5.5,0,5,5.1,9.4-.5,10.4-2.7l-39.6-44-39.6,44h0Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1265.1,756.6c-3.1,4.5-5.2,3.3-7.9,1.3-.6-.4-3.1-.5-3.6,0-5.9,6.5-18.7,1.1-17.9-1.4-6,4.9-11.8,6-17.5,2.1-1.1-.9-2.1-1.9-4,0-3.7,3.8-6.9-.4-7.7-2l29.2-32.5,29.3,32.6h0Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1212.8,742.2c2.4,3.6,4.1,2.6,6.2,1.1.5-.3,2.4-.4,2.8,0,4.7,5.1,14.7.9,14.1-1.1,4.7,3.9,9.3,4.8,13.8,1.6.8-.7,1.6-1.5,3.2,0,2.9,3,5.5-.3,6.1-1.6l-23.1-25.6-23.1,25.7h0Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1216.7,730.9c2,4.4,3.3,3.2,5.1,1.3.4-.4,2-.5,2.3,0,3.8,6.4,12.1,1.1,11.6-1.3,3.9,4.8,7.6,5.9,11.3,2,.7-.8,1.4-1.8,2.6,0,2.4,3.7,4.5-.4,5-2l-18.9-31.9-19,31.9Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M299.3,810.6h-14.7v20.4h14.7v-20.4Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M342.7,810.8c-5.3,7.8-8.9,5.7-13.6,2.3-1-.7-5.3-.9-6.2,0-10.3,11.2-32.3,1.9-31-2.3-10.3,8.5-20.4,10.4-30.2,3.5-1.8-1.5-3.6-3.2-7,0-6.4,6.5-12-.7-13.4-3.5l50.6-56.3,50.7,56.3h.1Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M252.1,786c4.1,6.1,7,4.5,10.7,1.8.8-.6,4.1-.7,4.8,0,8,8.8,25.3,1.5,24.2-1.8,8.1,6.7,15.9,8.2,23.6,2.8,1.4-1.2,2.8-2.5,5.5,0,5,5.1,9.4-.5,10.4-2.7l-39.6-44-39.6,44h0Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M321.1,764.8c-3.1,4.5-5.2,3.3-7.9,1.3-.6-.4-3.1-.5-3.6,0-5.9,6.5-18.7,1.1-17.9-1.4-6,4.9-11.8,6-17.5,2.1-1.1-.9-2.1-1.9-4,0-3.7,3.8-6.9-.4-7.7-2l29.2-32.5,29.3,32.6h.1Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M268.7,750.3c2.4,3.6,4.1,2.6,6.2,1.1.5-.3,2.4-.4,2.8,0,4.7,5.1,14.7.9,14.1-1.1,4.7,3.9,9.3,4.8,13.8,1.6.8-.7,1.6-1.5,3.2,0,2.9,3,5.5-.3,6.1-1.6l-23.1-25.6-23.1,25.7h0Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M272.7,739c2,4.4,3.3,3.2,5.1,1.3.4-.4,2-.5,2.3,0,3.8,6.4,12.1,1.1,11.6-1.3,3.9,4.8,7.6,5.9,11.3,2,.7-.8,1.4-1.8,2.6,0,2.4,3.7,4.5-.4,5-2l-18.9-31.9-19,31.9Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M111.8,799.6h-14.7v20.4h14.7v-20.4Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M155.2,799.8c-5.3,7.8-8.9,5.7-13.6,2.3-1-.7-5.3-.9-6.2,0-10.3,11.2-32.3,1.9-31-2.3-10.3,8.5-20.4,10.4-30.2,3.5-1.8-1.5-3.6-3.2-7,0-6.4,6.5-12-.7-13.4-3.5l50.6-56.3,50.7,56.3h.1Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M64.7,775c4.1,6.1,7,4.5,10.7,1.8.8-.6,4.1-.7,4.8,0,8,8.8,25.3,1.5,24.2-1.8,8.1,6.7,15.9,8.2,23.6,2.8,1.4-1.2,2.8-2.5,5.5,0,5,5.1,9.4-.5,10.4-2.7l-39.6-44-39.6,44h0Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M133.6,753.8c-3.1,4.5-5.2,3.3-7.9,1.3-.6-.4-3.1-.5-3.6,0-5.9,6.5-18.7,1.1-17.9-1.4-6,4.9-11.8,6-17.5,2.1-1.1-.9-2.1-1.9-4,0-3.7,3.8-6.9-.4-7.7-2l29.2-32.5,29.3,32.6h0Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M81.3,739.4c2.4,3.6,4.1,2.6,6.2,1.1.5-.3,2.4-.4,2.8,0,4.7,5.1,14.7.9,14.1-1.1,4.7,3.9,9.3,4.8,13.8,1.6.8-.7,1.6-1.5,3.2,0,2.9,3,5.5-.3,6.1-1.6l-23.1-25.6-23.1,25.7h0Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M85.3,728c2,4.4,3.3,3.2,5.1,1.3.4-.4,2-.5,2.3,0,3.8,6.4,12.1,1.1,11.6-1.3,3.9,4.8,7.6,5.9,11.3,2,.7-.8,1.4-1.8,2.6,0,2.4,3.7,4.5-.4,5-2l-18.9-31.9-19,31.9Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M390.9,813.1c.1.3-2.8,1.3-3.1,1.3-1.7.2-2.7,1.5-1.4,2.4,1.6,1.1,3.9-.2,5.6-1.3l-1.1-2.5h0Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M392.8,800.5c.1,0,.1-3.3.4-3.7,1.5-2,3.2,2,3.3,3l-3.8.7h.1Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M391.4,808.5s-5,13.3,0,18.7c0,0-5.4,1.5-1.1,3.1,0,0,5.6,1.4,6.7-1,0,0,3.2-.6,3.5-.8,5.4-2.8,1.5-9.5-1.1-12.8-1.1-1.4-2.7-2.3-3.5-3.9-.3-.6-.5-1.2-.5-1.9s.1-2.5.6-2.6l-4.6,1.1h0Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M399.4,815.8c-1.1-1.4-2.7-2.3-3.5-3.9-.3-.6-.5-1.2-.5-1.9s.1-2.5.6-2.6c0,0-2.2.5-3.5.9,0,.5-.1,1.1-.1,1.6s.2,1.4.5,2c.8,1.7,2.4,2.8,3.5,4.3,2.4,3.2,5.8,9.4,2.6,12.8.8,0,1.5-.3,1.6-.4,5.4-2.8,1.5-9.5-1.1-12.8h-.1Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M390.1,815.8c.2.3-2.4,1.9-2.7,2-1.6.6-2.3,2-.9,2.6,1.8.7,3.8-1,5.2-2.4l-1.6-2.2h0Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M401.5,825.3s4.6,1.5,2.8-5c-.4-1.4-1.6-2.8-2.1-4.2-1-2.6-1.6-5.9-.6-8.6,1.5-4.1,9.5-9.2,13.1-5,2.6,3,1.2,10.5-3.6,10.3-1.4,0-3.5-1.4-3.8-2.9-.3,3.2-.6,7.2.5,10.3,1.6,4.5-2,10.2-7.1,7.5l.8-2.4h0Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M383.6,803.3s5.7-6.1,11.6-4.7c2.6.6,4.5,3.5,4.3,6.1-.3,2.9-3.3,5.5-6,6-1.9.3-4.4-.7-5.9-1.9,0,0-5.6-4-3.9-5.6h-.1Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M392.2,801.3c-3.4-.8-6.6.8-8.8,2.4-.5,1.8,4.2,5.1,4.2,5.1,1.5,1.2,4,2.2,5.9,1.9.7,0,1.4-.4,2.1-.8.5-.7.8-1.6.9-2.5.2-2.6-1.7-5.5-4.3-6.1h0Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M396,799.5s2.8-1.7,3.3-1.7c2.5.2.1,3.7-.7,4.4l-2.7-2.8h.1Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M384.4,804.2c0,.5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9,0,0,0,0Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M389.8,803.7c0,.4-.3.7-.7.7s-.7-.3-.7-.7.3-.7.7-.7.7.3.7.7h0Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M389,803.5c0,0-.1.2-.2.2s-.2,0-.2-.2.1-.2.2-.2h0c.1,0,.2,0,.2.2h0Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1304.2,814.1l-.5-2.9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1304.2,814.2l-3.4.5"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1313.2,819.7l-12.5-7.6"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1326.9,826.6l.5-2.9"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1326.9,826.8l3.4.5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1317.9,832.1l12.5-7.6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1399.3,863.7c3-.3,7.2-1.2,8-4.2.6-2.4-1.9-2.9-4.2-1.4-.4.3-4.9,2.1-5.1,1.5l1.2,4.1h0Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1399.1,838.2l-5.1-.9c0-1.6,2.5-6.9,4.7-4.2.4.7.4,5.1.7,5.1h-.2Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1391.6,851.1c.8.2,1,3.5,1,4.2,0,1-.3,2-.8,2.9-1.3,2.5-3.8,4.1-5.6,6.2-4.2,5.3-10.4,15.9-1.8,20.3.5.3,5.5,1.1,5.6,1.2,1.7,3.7,10.6,1.5,10.6,1.5,6.7-2.4-1.7-4.8-1.7-4.8,7.8-8.6,0-29.7,0-29.7l-7.2-1.8h0Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1386.2,864.4c-4.2,5.3-10.4,15.9-1.8,20.3.2,0,1.4.4,2.6.6-5-5.4.3-15.2,4-20.3,1.7-2.3,4.3-4,5.6-6.8.5-1,.7-2.1.8-3.2,0-.9,0-1.7-.2-2.6-2.1-.5-5.6-1.4-5.6-1.4.8.2,1,3.5,1,4.2,0,1-.3,2-.8,2.9-1.3,2.5-3.8,4.1-5.6,6.2h0Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1382.9,879.5l1.2,3.7c-8,4.2-13.7-4.7-11.2-11.9,1.8-4.9,1.3-11.2.7-16.3-.5,2.4-3.7,4.5-6,4.6-7.5.4-9.8-11.5-5.7-16.3,5.8-6.7,18.3,1.3,20.7,7.9,1.6,4.3.6,9.5-.9,13.7-.8,2.3-2.6,4.4-3.3,6.7-2.9,10.4,4.3,7.9,4.3,7.9h.2Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1411.2,844.5c2.7,2.5-6.2,8.8-6.2,8.8-2.4,1.8-6.3,3.5-9.3,3-4.4-.8-9.1-5-9.5-9.5-.4-4.1,2.6-8.8,6.7-9.7,9.4-2.2,18.3,7.5,18.3,7.5h0Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1397.7,841.3c-4.1,1-7.1,5.6-6.7,9.7.2,1.4.6,2.7,1.4,3.9,1,.6,2.2,1,3.3,1.2,3,.5,7-1.1,9.3-3,0,0,7.5-5.3,6.6-8.1-3.5-2.5-8.6-5-13.9-3.8h0Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1391.6,838.5l-4.2,4.4c-1.3-1.1-5.1-6.8-1.1-7,.8,0,5.1,2.8,5.3,2.7h0Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1410,845.9c0-.8.6-1.4,1.4-1.4s1.4.6,1.4,1.4-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4h0Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1401.3,845.2c0-.6.5-1.2,1.2-1.2s1.2.5,1.2,1.2-.5,1.2-1.2,1.2-1.2-.5-1.2-1.2h0Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1402.7,844.9h0c0-.2.2-.4.4-.4h0c.2,0,.4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4h0Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1412.2,851.3c-.9,1.9,1.3,4.9-4,4.8,0,0-.2.2-.4.4l-10.7,12.8v.2c0,0,0,.2-.2.3v.4c0,0,0,.2,0,.2h0c.2,8.7,7.5,6.8,10,5.9,0,0,0,0,.2,0l.2-.2v-.2h.3l.2-.2.2-.2,11.6-32.6-7.1,8.5h0Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1400,864.9c3,.6,7.3,1,8.8-1.6,1.3-2.1-.9-3.3-3.5-2.6-.4,0-5.3.6-5.3,0v4.2h0Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1406.6,837.3l-25.5,7.9.5,1.7,25.5-7.9-.5-1.7Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1403.6,835.3l-21.2,6.6.8,2.7,21.2-6.6-.8-2.7Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1321.5,815.3c.6,0,1.1-.4,1.2-1,0-.6-.4-1.1-1-1.2h0c-.6,0-1.1.6-1,1.2,0,.6.5,1,1,1h0Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1336.3,830l3.5,2,9.5-17-3.5-2-9.5,17Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1338.3,834.2c.3,0,.9-.4,1.3-1.3s.7-1.7.4-1.8-.9.4-1.3,1.3-.7,1.7-.4,1.8Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1336.1,833.1c.3,0,.9-.4,1.3-1.3s.7-1.7.4-1.8-.9.4-1.3,1.3-.7,1.7-.4,1.8Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1337.2,833.7c.3,0,.9-.4,1.3-1.3s.7-1.7.4-1.8-.9.4-1.3,1.3-.7,1.7-.4,1.8Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1335.1,832.5c.3,0,.9-.4,1.3-1.3s.7-1.7.4-1.8-.9.4-1.3,1.3-.7,1.7-.4,1.8Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1321.1,814.3c.2,0,.3,0,.3-.3s0-.3-.3-.3h0c-.2,0-.3,0-.3.3s0,.3.3.3Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1324.4,817c.6,0,1.1-.4,1.2-1,0-.6-.4-1.1-1-1.2h0c-.6,0-1.1.6-1,1.2,0,.6.5,1,1,1h0Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1398.6,819.3l-21.2,6.6,5,16,21.2-6.6-5-16Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1324,815.9c.2,0,.3,0,.3-.3s0-.3-.3-.3h0c-.2,0-.3,0-.3.3s0,.3.3.3Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1319.6,812.7c.6,0,1.1-.4,1.2-1,0-.6-.4-1.1-1-1.2h0c-.6,0-1.1.6-1,1.2,0,.6.5,1,1,1h0Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1319.1,811.6c.2,0,.3,0,.3-.3s0-.3-.3-.3h0c-.2,0-.3,0-.3.3s0,.3.3.3Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1356.9,806.4c2.3-7.6-2-15.7-9.6-18.1h0c-7.6-2.3-15.7,2-18.1,9.6-2.3,7.6,2,15.7,9.6,18.1,7.6,2.3,15.7-2,18.1-9.6Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1349,802.5c.3-1-.2-2-1.1-2.4h-.2c-1-.2-2,.4-2.2,1.3-.2,1,.4,2,1.3,2.2s1.9-.3,2.2-1.2h0Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1348.8,801.9c0-.3,0-.6-.4-.7s-.6,0-.7.4,0,.6.4.7.6,0,.7-.4Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1340.4,798.1c.3-1-.3-2-1.2-2.3s-2,.3-2.3,1.2.3,2,1.2,2.3,2-.3,2.3-1.2Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1340,797.6c0-.3,0-.6-.4-.7s-.6,0-.7.4,0,.6.4.7.6,0,.7-.4Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1333.8,806.8c0-.3,0-.6-.4-.7s-.6,0-.7.4,0,.6.4.7.6,0,.7-.4Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1334.7,808.1c0-.3,0-.6-.4-.7s-.6,0-.7.4,0,.6.4.7.6,0,.7-.4Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1335.7,809c0-.3,0-.6-.4-.7s-.6,0-.7.4,0,.6.4.7.6,0,.7-.4Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1337.1,809.7c0-.3,0-.6-.4-.7s-.6,0-.7.4,0,.6.4.7.6,0,.7-.4Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1338.5,810.5c0-.3,0-.6-.4-.7h0c-.3,0-.6,0-.7.4,0,.3,0,.6.4.7.3,0,.6,0,.7-.4Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1339.1,811.3c.3,0,.6,0,.7-.4s0-.6-.4-.7h0c-.3,0-.6,0-.7.4,0,.3,0,.6.4.7h0Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1340.5,811.7c.3,0,.6,0,.7-.4s0-.6-.4-.7h0c-.3,0-.6,0-.7.4,0,.3,0,.6.4.7h0Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1342.7,811.6c0-.3,0-.6-.4-.7h0c-.3,0-.6,0-.7.4,0,.3,0,.6.4.7.3,0,.6,0,.7-.4Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1343.4,811.7h0c.3,0,.6,0,.7-.4s0-.6-.4-.7h0c-.3,0-.6,0-.7.4,0,.3,0,.6.4.7h0Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1345.5,811c0-.3,0-.6-.4-.7s-.6,0-.7.4,0,.6.4.7.6,0,.7-.4Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1333,805.6c0-.3,0-.6-.4-.7h0c-.3,0-.6,0-.7.4,0,.3,0,.6.4.7.3,0,.6,0,.7-.4Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1346.1,810.7c.3,0,.6,0,.7-.4,0-.3,0-.6-.4-.7-.3,0-.6,0-.7.4s0,.6.4.7h0Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M812.6,899"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M822,897.8c-49.6,38.5-127.3,86-230,102.2-20.5,3.2-40.1,4.9-58.6,5.5"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M727.9,980.8"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M221.2,781.7c0,.6-.3,1-.4,1s0-.5,0-1v-1s.3.4.3,1h0Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M372.6,832.6c2.9.5,5,2.3,4.8,3.8-.3,1.6-2.9,2.5-5.9,1.9-2.9-.5-5-2.3-4.8-3.8s2.9-2.5,5.9-1.9Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M369.2,835c.2-1,.7-2,1.5-2.7h-.4c-1.7-.3-3.4.7-3.7,2.3s.9,3.1,2.7,3.4h.4c-.5-.9-.6-2-.5-3h0Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M367,834.4c0,0,.2.2.2.3s-.2.2-.3.2h0l-1.2-.2c0,0-.2-.2-.2-.3s.2-.2.3-.2h0l1.1.2h0Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M367.6,836c.2,0,.3.2.3.3s-.2.2-.4.2-.3-.2-.3-.3.2-.2.4,0h0Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M368.6,836.8c.2,0,.3.2.3.3s-.2.2-.4,0-.3-.2-.3-.3.2-.2.4,0Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M368.7,835.4c.2,0,.3.2.3.3s-.2.2-.4,0-.3-.2-.3-.3.2-.2.4-.2h0Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M367.7,833.8c.2,0,.3.2.3.3s-.2.2-.4,0-.3-.2-.3-.3.2-.2.4,0Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M369.1,832.7c.2,0,.3.2.3.3s-.2.2-.4,0c-.2,0-.3-.2-.3-.3s.2-.2.4,0Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M368.8,833.8c.2,0,.3.2.3.3s-.2.2-.4,0-.3-.2-.3-.3.2-.2.4,0Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M357.2,824.7l-.8,1.8c1.2.8,2.9,1.8,4.1,1,1-.7.2-1.6-1-1.8-.2,0-2.4-.7-2.3-1h0Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M375.6,834.3c.7.6,1,1.4.8,1.5s-.5-.5-1.2-1-1.3-.8-1.3-1,.8,0,1.6.6h0Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M362.3,827.3c0,2.2-1.2,4.1-2.4,4-1.2,0-2.2-1.9-2.1-4.2,0-2.2,1.2-4.1,2.4-4s2.2,1.9,2.1,4.2Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M360.2,824.9c.8,0,1.6.3,2.2.8,0,0,0-.2,0-.3,0-1.3-.9-2.5-2.1-2.5-1.2,0-2.2,1-2.3,2.4,0,0,0,.2,0,.3.6-.4,1.5-.7,2.2-.6h0Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M360.4,823.3v.2c-.1,0-.3,0-.4-.1h0v-.9s0-.2.1-.2h.2c0,.1,0,1,0,1Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M359.3,823.8v.2c-.1,0-.3,0-.3-.3v-.2c.1,0,.3,0,.3.3Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M358.8,824.7v.2c-.1,0-.3,0-.3-.3s.1-.2.1-.2c0,0,.2,0,.1.3Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M359.8,824.6v.2c-.1,0-.3,0-.3-.3s.1-.2.1-.2c0,0,.2,0,.1.3Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M360.9,823.7v.2c-.1,0-.3,0-.3-.3s.1-.2.1-.2c0,0,.2,0,.1.3Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M361.9,824.7v.2c-.1,0-.3,0-.3-.3v-.2c.1,0,.3,0,.3.3Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M361.1,824.5v.2c-.1,0-.3,0-.3-.3s.1-.2.1-.2c0,0,.2,0,.1.3Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M361.4,829.7c-.4.7-1,.9-1,.8s.3-.5.6-1.1l.6-1.1c0,0,.1.7-.3,1.2h.2Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M355.9,815.5h0l-2.8-.5c0-.7,1.3-3.7,2.4-2.2.2.3.2,2.7.3,2.7h0Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M356.8,821.3l-3.4-.8c.4,0,.4,1.6.4,1.9,0,.5-.1,1-.4,1.4-.6,1.2-1.8,1.8-2.6,2.9-1.9,2.4-4.8,7.4-.8,9.4.2.1,2.6.6,2.6.6.8,1.8,4.9.7,4.9.7,3.2-1.2-.8-2.3-.8-2.3,3.7-4,0-13.7,0-13.7h0Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M350.9,826.8h0c-1.9,2.4-4.8,7.4-.8,9.4,0,0,.6.2,1.2.3-2.4-2.5.1-7.1,1.9-9.4.8-1.1,2-1.9,2.6-3.2.2-.4.4-1,.4-1.5s0-.8,0-1.2c-1-.3-2.6-.7-2.6-.7.4,0,.4,1.6.4,1.9,0,.5-.1,1-.4,1.4-.6,1.2-1.8,1.8-2.6,2.9h0Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M357.8,826.8l-1.2,1.6c1,1,2.5,2.3,3.8,1.8,1-.4.5-1.5-.7-1.9-.2,0-2.1-1.2-2-1.5h0Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M349.4,833.7h0l.6,1.8c-3.7,2-6.4-2.2-5.2-5.5.8-2.3.6-5.2.4-7.6-.2,1.1-1.8,2.1-2.8,2.1-3.5.1-4.6-5.4-2.6-7.6,2.6-3.1,8.5.7,9.6,3.7.7,2,.3,4.4-.4,6.3-.4,1-1.2,2.1-1.5,3.1-1.3,4.8,2.1,3.7,2.1,3.7h0Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M362.5,817.5h0c1.2,1.2-2.9,4.1-2.9,4.1-1.1.9-2.9,1.6-4.3,1.4-2-.4-4.2-2.3-4.4-4.4-.1-1.9,1.2-4,3.2-4.5,4.3-1,8.5,3.5,8.5,3.5h0Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M356.2,816.1h0c-1.9.4-3.3,2.6-3.2,4.5,0,.7.3,1.3.7,1.8.5.3,1,.5,1.5.6,1.4.2,3.2-.5,4.3-1.4,0,0,3.5-2.4,3.1-3.7-1.6-1.2-4-2.4-6.5-1.8h0Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M353.5,814.7h0l-2,2.1c-.6-.5-2.4-3.1-.5-3.2.4,0,2.4,1.2,2.4,1.2h0Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M362,818.2c0-.4.3-.7.7-.7s.7.3.7.7-.3.7-.7.7-.7-.3-.7-.7c0,0,0,.4,0,0Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M358,817.9c0-.3.2-.5.5-.5s.5.2.5.5-.2.5-.5.5-.5-.2-.5-.5h0Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M358.6,817.7h0c0,0,0-.1.1-.1h0c0,0,.1,0,.1.1s0,.1-.1.1-.1,0-.1-.1h0Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M368.9,818.6c1.2-.4,2.7,1.1,3.4,3.3.7,2.2.3,4.3-1,4.7-1.2.4-2.7-1.1-3.4-3.3-.7-2.2-.3-4.3,1-4.7Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M369.5,820.5c.7-.3,1.5-.2,2.3,0,0-.1,0-.2,0-.3-.4-1.3-1.7-2-2.9-1.7s-1.8,1.8-1.4,3c0,.1,0,.2.1.2.4-.6,1.1-1.1,1.9-1.4h0Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M368.4,817.9h0c0,0,0-.2.1-.2s.2,0,.2.1l.3.8h0c0,0,0,.2-.1.2s-.2,0-.2-.1l-.3-.8Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M370.2,818.9l.2.2c0,.2,0,.3,0,.3l-.2-.2c0-.2,0-.3,0-.3Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M370.8,819.5c0,0,.2,0,.2.2s0,.3,0,.3l-.2-.2c0-.2,0-.3,0-.3Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M369.7,819.7c0,0,.2,0,.2.2s0,.3,0,.3l-.2-.2c0-.2,0-.3,0-.3Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M368.4,819.1c0,0,.2,0,.2.2s0,.3,0,.3l-.2-.2c0-.2,0-.3,0-.3Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M367.8,820.4l.2.2c0,.2,0,.3,0,.3l-.2-.2c0-.2,0-.2,0-.3Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M368.5,819.9c0,0,.2,0,.2.2s0,.3,0,.3l-.2-.2c0-.2,0-.3,0-.3Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M369.5,825.3c-.6-.5-.7-1.1-.6-1.2,0,0,.4.5.9.9s1,.7.9.9-.7,0-1.2-.5h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 612.7,
    y: 827.9,
    width: 1.5,
    height: 24.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 613.5,
    cy: 818.3,
    rx: 1.3,
    ry: 3.8
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 616.7,
    cy: 818.9,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-406 889.6) rotate(-57)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 613.5,
    cy: 835.8,
    rx: 1.3,
    ry: 3.8
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 622.5,
    cy: 827.2,
    rx: 3.8,
    ry: 1.3
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 604.1,
    cy: 827,
    rx: 3.8,
    ry: 1.3
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 610.3,
    cy: 834.9,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-398 1064.6) rotate(-66.7)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 610.3,
    cy: 818.9,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-290.6 337.8) rotate(-25.2)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 619.3,
    cy: 833.4,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-407.9 682) rotate(-45)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 616.5,
    cy: 834.9,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-296.8 342) rotate(-25.2)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 607.4,
    cy: 821.4,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-402.9 670) rotate(-45)"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 607.4,
    cy: 833,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-376.3 524.5) rotate(-36.5)"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 619.7,
    cy: 820.9,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-366.7 529.5) rotate(-36.5)"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 621.5,
    cy: 823.6,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-291.5 343.1) rotate(-25.2)"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 605.6,
    cy: 830.1,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-295.8 336.9) rotate(-25.2)"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 605.1,
    cy: 823.6,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-384.5 1078.8) rotate(-68.2)"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 621.5,
    cy: 830.5,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-380.6 1098.4) rotate(-68.2)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 613.5,
    cy: 826.7,
    r: 5.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 638.9,
    y: 835.5,
    width: 1.5,
    height: 24.8
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 639.6,
    cy: 825.9,
    rx: 1.3,
    ry: 3.8
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 642.9,
    cy: 826.5,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-400.4 915) rotate(-57)"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 639.6,
    cy: 843.4,
    rx: 1.3,
    ry: 3.8
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 648.7,
    cy: 834.8,
    rx: 3.8,
    ry: 1.3
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 630.3,
    cy: 834.6,
    rx: 3.8,
    ry: 1.3
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 636.5,
    cy: 842.5,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-389.2 1093.2) rotate(-66.7)"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 636.5,
    cy: 826.5,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-291.3 349.7) rotate(-25.2)"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 645.5,
    cy: 841,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-405.6 702.8) rotate(-45)"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 642.7,
    cy: 842.5,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-297.6 353.9) rotate(-25.2)"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 633.5,
    cy: 829,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-400.6 690.8) rotate(-45)"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 633.5,
    cy: 840.6,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-375.7 541.6) rotate(-36.5)"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 645.9,
    cy: 828.5,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-366.1 546.6) rotate(-36.5)"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 647.7,
    cy: 831.2,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-292.3 354.9) rotate(-25.2)"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 631.8,
    cy: 837.7,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-296.6 348.8) rotate(-25.2)"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 631.3,
    cy: 831.2,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-375.1 1107.9) rotate(-68.2)"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 647.7,
    cy: 838.1,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-371.2 1127.5) rotate(-68.2)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 639.6,
    cy: 834.3,
    r: 5.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 665.2,
    y: 844.3,
    width: 1.5,
    height: 24.8
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 665.9,
    cy: 834.7,
    rx: 1.3,
    ry: 3.8
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 669.2,
    cy: 835.2,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-395.8 941) rotate(-57)"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 665.9,
    cy: 852.2,
    rx: 1.3,
    ry: 3.8
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 675,
    cy: 843.6,
    rx: 3.8,
    ry: 1.3
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 656.6,
    cy: 843.3,
    rx: 3.8,
    ry: 1.3
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 662.8,
    cy: 851.3,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-381.4 1122.7) rotate(-66.7)"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 662.8,
    cy: 835.2,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-292.6 361.8) rotate(-25.2)"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 671.8,
    cy: 849.7,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-404.1 723.9) rotate(-45)"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 669,
    cy: 851.3,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-298.8 365.9) rotate(-25.2)"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 659.8,
    cy: 837.8,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-399.1 711.9) rotate(-45)"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 659.8,
    cy: 849.4,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-375.8 558.9) rotate(-36.5)"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 672.2,
    cy: 837.3,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-366.2 563.9) rotate(-36.5)"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 674,
    cy: 840,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-293.5 367) rotate(-25.2)"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 658.1,
    cy: 846.5,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-297.8 360.8) rotate(-25.2)"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 657.6,
    cy: 840,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-366.8 1137.8) rotate(-68.2)"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 674,
    cy: 846.9,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-362.8 1157.4) rotate(-68.2)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 665.9,
    cy: 843.1,
    r: 5.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 585.1,
    y: 823.3,
    width: 1.5,
    height: 24.8
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 585.8,
    cy: 813.7,
    rx: 1.3,
    ry: 3.8
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 589,
    cy: 814.2,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-414.7 864.2) rotate(-57)"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 585.8,
    cy: 831.1,
    rx: 1.3,
    ry: 3.8
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 594.8,
    cy: 822.5,
    rx: 3.8,
    ry: 1.3
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 576.4,
    cy: 822.3,
    rx: 3.8,
    ry: 1.3
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 582.7,
    cy: 830.3,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-410.5 1036.4) rotate(-66.7)"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 582.7,
    cy: 814.2,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-291.2 325.6) rotate(-25.2)"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 591.7,
    cy: 828.7,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-412.7 661.1) rotate(-45)"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 588.9,
    cy: 830.3,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-297.5 329.8) rotate(-25.2)"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 579.7,
    cy: 816.7,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-407.7 649.1) rotate(-45)"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 579.7,
    cy: 828.4,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-379 507.2) rotate(-36.5)"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 592,
    cy: 816.3,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-369.4 512.1) rotate(-36.5)"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 593.9,
    cy: 818.9,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-292.2 330.8) rotate(-25.2)"
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 577.9,
    cy: 825.5,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-296.5 324.7) rotate(-25.2)"
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 577.5,
    cy: 818.9,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-397.6 1050.2) rotate(-68.2)"
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 593.9,
    cy: 825.8,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-393.6 1069.8) rotate(-68.2)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 585.8,
    cy: 822,
    r: 5.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 556.7,
    y: 815.7,
    width: 1.5,
    height: 24.8
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 557.4,
    cy: 806.1,
    rx: 1.3,
    ry: 3.8
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 560.6,
    cy: 806.6,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-421.2 837) rotate(-57)"
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 557.4,
    cy: 823.5,
    rx: 1.3,
    ry: 3.8
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 566.4,
    cy: 815,
    rx: 3.8,
    ry: 1.3
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 548,
    cy: 814.7,
    rx: 3.8,
    ry: 1.3
  })), _ellipse71 || (_ellipse71 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 554.3,
    cy: 822.7,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-420.7 1005.7) rotate(-66.7)"
  })), _ellipse72 || (_ellipse72 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 554.3,
    cy: 806.6,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-290.7 312.8) rotate(-25.2)"
  })), _ellipse73 || (_ellipse73 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 563.3,
    cy: 821.1,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-415.6 638.8) rotate(-45)"
  })), _ellipse74 || (_ellipse74 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 560.5,
    cy: 822.7,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-297 317) rotate(-25.2)"
  })), _ellipse75 || (_ellipse75 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 551.3,
    cy: 809.1,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-410.7 626.8) rotate(-45)"
  })), _ellipse76 || (_ellipse76 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 551.3,
    cy: 820.8,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-380 488.8) rotate(-36.5)"
  })), _ellipse77 || (_ellipse77 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 563.6,
    cy: 808.7,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-370.4 493.7) rotate(-36.5)"
  })), _ellipse78 || (_ellipse78 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 565.5,
    cy: 811.4,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-291.7 318) rotate(-25.2)"
  })), _ellipse79 || (_ellipse79 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 549.5,
    cy: 817.9,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-296 311.9) rotate(-25.2)"
  })), _ellipse80 || (_ellipse80 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 549,
    cy: 811.4,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-408.3 1019.1) rotate(-68.2)"
  })), _ellipse81 || (_ellipse81 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 565.5,
    cy: 818.2,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-404.4 1038.6) rotate(-68.2)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 557.4,
    cy: 814.4,
    r: 5.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 525.6,
    y: 810,
    width: 1.5,
    height: 24.8
  })), _ellipse82 || (_ellipse82 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 526.3,
    cy: 800.4,
    rx: 1.3,
    ry: 3.8
  })), _ellipse83 || (_ellipse83 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 529.5,
    cy: 800.9,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-430.6 808.3) rotate(-57)"
  })), _ellipse84 || (_ellipse84 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 526.3,
    cy: 817.8,
    rx: 1.3,
    ry: 3.8
  })), _ellipse85 || (_ellipse85 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 535.4,
    cy: 809.2,
    rx: 3.8,
    ry: 1.3
  })), _ellipse86 || (_ellipse86 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 517,
    cy: 809,
    rx: 3.8,
    ry: 1.3
  })), _ellipse87 || (_ellipse87 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 523.2,
    cy: 816.9,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-434.2 973.7) rotate(-66.7)"
  })), _ellipse88 || (_ellipse88 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 523.2,
    cy: 800.9,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-291.2 299) rotate(-25.2)"
  })), _ellipse89 || (_ellipse89 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 532.2,
    cy: 815.4,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-420.7 615.1) rotate(-45)"
  })), _ellipse90 || (_ellipse90 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 529.4,
    cy: 816.9,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-297.5 303.2) rotate(-25.2)"
  })), _ellipse91 || (_ellipse91 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 520.2,
    cy: 803.4,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-415.7 603.2) rotate(-45)"
  })), _ellipse92 || (_ellipse92 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 520.2,
    cy: 815.1,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-382.7 469.2) rotate(-36.5)"
  })), _ellipse93 || (_ellipse93 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 532.6,
    cy: 803,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-373.1 474.2) rotate(-36.5)"
  })), _ellipse94 || (_ellipse94 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 534.4,
    cy: 805.6,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-292.2 304.3) rotate(-25.2)"
  })), _ellipse95 || (_ellipse95 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 518.5,
    cy: 812.2,
    rx: 3.8,
    ry: 1.3,
    transform: "translate(-296.5 298.1) rotate(-25.2)"
  })), _ellipse96 || (_ellipse96 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 518,
    cy: 805.6,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-422.5 986.7) rotate(-68.2)"
  })), _ellipse97 || (_ellipse97 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 534.4,
    cy: 812.5,
    rx: 1.3,
    ry: 3.8,
    transform: "translate(-418.6 1006.2) rotate(-68.2)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 526.3,
    cy: 808.7,
    r: 5.8
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpringOverlay);
export default __webpack_public_path__ + "static/media/SpringOverlay.a6bd94947aa208ce6e461936acb00651.svg";
export { ForwardRef as ReactComponent };